export function DroneComplect() {
  return (
    <table>
      <tbody>
      <tr style={{height: 200}}>
        <td><img src="../../assets/images/motor.png" alt="Motor"/></td>
        <td><img src="../../assets/images/camera.png" alt="fc"/></td>
        <td><img src="../../assets/images/motor.png" alt="Motor"/></td>
      </tr>
      <tr style={{ height: 200 }}>
        <td></td>
        <td valign="middle" align="center">
          <img src="../../assets/images/fc_esc.png" alt="fc" />
        </td>
        <td><img src="../../assets/images/receiver.png"/></td>
      </tr>
      <tr style={{ height: 200 }}>
        <td></td>
        <td><img src="../../assets/images/vtx.png" alt="VTX"/></td>
        <td></td>
      </tr>
      <tr style={{ height: 200 }}>
        <td><img src="../../assets/images/motor.png" alt="Motor"/></td>
        <td>Pigtail</td>
        <td><img src="../../assets/images/motor.png" alt="Motor"/></td>
      </tr>
      <tr style={{ height: 200 }}>
        <td></td>
        <td><img src="../../assets/images/antenaVtx.png" alt="Antena"/></td>
        <td></td>
      </tr>
      </tbody>
    </table>
  );
}

export default DroneComplect;
